<template>
  <div class="dentrion_header">
    <img
      width="150px"
      src="../assets/image/dentrion_logo.svg"
      alt="DENTRION"
    />
  </div>
  <div class="intro_container">
    <div class="font_container">
      <div class="header_title">
        <h1 data-aos="fade-up" data-aos-duration="400">Reduce</h1>
        <h1 data-aos="fade-up" data-aos-duration="600">Chair time &</h1>
        <h1 data-aos="fade-up" data-aos-duration="800">Resources</h1>
      </div>
      
      <!-- Image Card with Slider -->
      <div class="image_card" data-aos="fade-in" data-aos-duration="800">
        <transition name="slide">
          <img :key="currentImage" :src="currentImage" alt="Intro Image" />
        </transition>
      </div>

      <div class="header_sub">
        <p>Elevate your practice with DENTRION.</p>
        <p>Experience precision-crafted dental prosthetics,</p>
        <p>seamless digital workflows,</p>
        <p>and dedicated lab support</p>
        <p>tailored to your practice.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require("../assets/image/intro_01.svg"),
        require("../assets/image/intro_02.svg"),
        require("../assets/image/intro_03.svg"),
      ],
      currentIndex: 0,
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    },
  },
  mounted() {
    this.startSlider();
  },
  methods: {
    startSlider() {
      // 1번 이미지 고정 후 3초마다 전환 (0 -> 1 -> 2 -> 0 ...)
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
      }, 3000);
    },
  },
};
</script>
<style scoped>
/* 전체 컨테이너 스타일 */
.intro_container {
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.dentrion_header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 33px 0;
  background-color: black;
  width: 100%;
}

/* 폰트 컨테이너 스타일 */
.font_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 56px;
  padding: 60px 23px;
}

/* 타이틀 컨테이너 스타일 */
.header_title {
  text-align: center;
  color: #bee0c7;
  display: flex;
  flex-direction: column;
  gap: 0px;
}
.header_title > h1 {
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-weight: 900; /* Black */
  margin: 0;
  font-size: 40px;
  line-height: 1.28;
  letter-spacing: -2px;
}

/* 이미지 카드 스타일 (Figma: 1p) */
.image_card {
  width: 360px;
  height: 240px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative; /* 트랜지션 포지셔닝용 */
}

.image_card img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 이미지가 잘리지 않도록 contain 또는 cover */
  position: absolute;
  top: 0;
  left: 0;
}

.header_sub {
  text-align: center;
  color: #bee0c7;
  line-height: 1.28;
  font-size: 18px;
  font-weight: 500; /* Medium */
  letter-spacing: -0.9px;
}

/* Slide Transition (Move to Left) */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease-in-out;
}

.slide-enter-from {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
.slide-enter-to,
.slide-leave-from {
  transform: translateX(0);
}
</style>
